"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tag = exports.SelectItem = exports.NotFoundContent = void 0;
var _Nodate = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/general/Nodate.svg"));
var _classnames = _interopRequireDefault(require("classnames"));
var _spin = _interopRequireDefault(require("../spin"));
var _icon = _interopRequireDefault(require("../icon"));
var _useThemeSwitch = require("../hooks/useThemeSwitch");
var _react = _interopRequireDefault(require("react"));
var _useConfig = require("../hooks/useConfig");
var _jsxRuntime = require("react/jsx-runtime");
const NotFoundContent = _ref => {
  let {
    optionsLoading
  } = _ref;
  const [theme, colors] = (0, _useThemeSwitch.useTheme)();
  const {
    locale: {
      Select: SelectLocale
    }
  } = (0, _useConfig.useConfig)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      color: colors['--zen-design-onSurface-low-color']
    },
    children: optionsLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_spin.default, {}) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
        type: "general/Nodate",
        fontSize: 48
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: SelectLocale.noData
      })]
    })
  });
};
exports.NotFoundContent = NotFoundContent;
const Tag = props => {
  const {
    text,
    size = 'm'
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _classnames.default)('select-item-tag', size),
    children: text
  });
};
exports.Tag = Tag;
const SelectItem = props => {
  const {
    name,
    suffix
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "select-item",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "name",
      children: name
    }), suffix]
  });
};
exports.SelectItem = SelectItem;